import { gql } from '@apollo/client';
const MOVE_PRODUCT_CATEGORY = gql `
  mutation MoveProductCategory($productCategoryId: ID!, $direction: String!) {
    moveProductCategory(productCategoryId: $productCategoryId, direction: $direction) {
      productCategories {
        id
        type
        typeLabelPL
        typeLabelEN
        typeIcon
        displayOrder
        filtersAvailable
        productsCount
      }
    }
  }
`;
export default MOVE_PRODUCT_CATEGORY;
